export const VEHICLE_ADA = Object.freeze({
  FORWARD: 'FORWARD',
  BACKWARD: 'BACKWARD',
  ADA_CLASS: 'vehicle-builder-list__ada',
  CARD_BODY: 'card-body',
  HEADER_ARROW_BACK: 'icon-arrow__back button-header__icon'
});



// WEBPACK FOOTER //
// ./src/constants/vehicleADA.js